import React from "react"
import { SECTION_TYPES, getURLFromSectionName } from "./SectionTypes"
import { ClassHocCarousel } from "../../components/ReusableComponents/LiveClassTile/ClassBox/ClassBox"
import CategoryCarousel from "../../components/ReusableComponents/CategoryCarousel/CategoryCarousel"
import { OndemandHocCarousel } from "../../components/ReusableComponents/VideoUI/VideoUI"
import ClassesForCategoryCarousel from "../../components/ReusableComponents/ClassesForCategoryCarousel/ClassesForCategoryCarousel"

export function Section({ section, gym, categories }) {
  const url = getURLFromSectionName(section.section_name)
  switch (section.section_type) {
    case SECTION_TYPES.BOOKED_CLASS:
      return (
        <ClassHocCarousel
          heading={section.section_heading}
          url={"_listBookedActivities"}
          gymIds={[gym.gym_id]}
        />
      )
    case SECTION_TYPES.CATEGORY:
      return <CategoryCarousel />
    case SECTION_TYPES.ONDEMAND_CLASS:
      if (url) {
        return (
          <OndemandHocCarousel
            heading={section.section_heading}
            url={url}
            gymIds={[gym.gym_id]}
            tileSize="small"
            showNewTag={section.section_settings.is_new_tag_enabled}
            showExploreAll={section.section_settings.is_see_all_required}
          />
        )
      } else {
        return null
      }
    case SECTION_TYPES.TRENDING_CLASS:
      if (url) {
        return (
          <OndemandHocCarousel
            heading={section.section_heading}
            url={"_ondemandActivities"}
            gymIds={[gym.gym_id]}
            tileSize="small"
          />
        )
      } else {
        return null
      }
    case SECTION_TYPES.FEATURED_CLASS:
      return categories.length
        ? categories.map((category) => (
            <ClassesForCategoryCarousel category={category} />
          ))
        : null
    default:
      return null
  }
}
